interface Props {
    link: string;
    class?: string;
    children: React.ReactNode
}

export default function Button(props: Props) {
    return (
        <a href={props.link} target="_blank" rel="noreferrer" className={`rounded-md transition duration-300 ${props.class ? props.class : ""}`}>
            {props.children}
        </a>
    );
}